import './Tablets.scss';

export const Tablets = () => {
  return (
    <h1>Tablets</h1>
  );
}